<template>
  <div>
    <div  v-if="isScrolled9">
      <Header/>
    </div>
    <div style="height: 5em;"></div>
    <div class="Breadcrumbs">
      <div class="box">
        <a href='/' class=''>{{ $t('message.home') }}</a> &gt; <a href='/price/'>{{ $t('message.price') }}</a>
      </div>
    </div>

    <!-- price -->
    <div class="price">
      <div class="box">
        <h2 class="title">{{ $t('message.priceTitle') }}</h2>

        <!-- <div class="txt">{{ $t('message.proMemberCount') }}</div> -->

        <div class="txt">{{ $t('message.proMemberCount') }}</div>

        <!-- 暂时注释团队版切换按钮 -->
        <!-- <div class="cbox">
          <div  @click="Persion1" style=""
                :style="{ backgroundColor: isTeam === false ? '#48a2f8' : '#f2f3f8',
           color: isTeam === false ? '#ffffff' : '#48a2f8'
            }"
                class="item on " data-id="1">{{ $t('message.personalVersion') }}</div>

          <div   @click="Persion2"
                 :style="{ backgroundColor: isTeam === true ? '#48a2f8' : '#f2f3f8',
           color: isTeam === true ? '#ffffff' : '#48a2f8'
            }"
                 class="item on" data-id="2">
            {{ $t('message.teamVersion') }}
          </div>
        </div> -->

        <div class="pbox">
          <!-- 个人版 -->
          <div>
            <div class="item box1 on  f_thb1">
              <div style="display: flex;justify-content: center;align-items: center">
                <div style="height: auto;width: 50%;" >
                  <div v-for="item in personalPlans" :key="item.id" style="float: left;height: auto;width: 300px;">
                    <div class="tbox th">
                      <div class="pbbs">
                        <div class="options" >
                          <div class="t1">{{ $t('message.price_' + item.id) || item.name }}</div>
                          <h4 class="t2">¥ {{ item.price }}.00</h4>
                          <div class="t3"></div>
                          <div class="t4" style="white-space: normal;" v-html="$t('message.price_desc_' + item.id) || item.description.replace(/\n/g, '<br>')"></div>
                          <a  @click="perChase(item)" class="buy" order-id="233">{{ $t('message.buyNow') }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="margin-top: 100px" class="tips">
                {{ $t('message.payTip') }} <a href="/privacy">{{ $t('message.privacy') }}</a>
                <br>
                {{ $t('message.invoiceTip') }}
              </div>
            </div>
          </div>
          <!-- 暂时注释团队版 -->
          <!-- <div v-if="isTeam">
            <div  class="item box2 on  ">
              <div class="select-box">
                <div   class="select ">
                  <div  @click="open" class="add" data-id="">
                    <span style="width: 85%"> {{ member}}</span>
                    <i    class="el-icon-arrow-down el-icon--right"></i>
                  </div>
                  <transition name="fade">
                    <div  v-if="personShow" class="person-container">
                      <div  v-for="m in teamMemberOptions" :key="m.id" >
                        <div style="color: #9fa19f"  class="person" @click="selectMember(m)">{{ m.title}}</div>
                      </div>
                    </div>
                  </transition>
                </div>

                <div  class="select ">
                  <div @click="open2" class="add" data-id="">
                    <span style="width: 85%"> {{ time}}</span>
                    <i      class="el-icon-arrow-down el-icon--right"></i> 
                  </div>
                  <transition name="fade">
                    <div v-if="personShow2"  class="person-container">
                      <div v-for="m in personalPlans" :key="m.id" >
                        <div  style="color: #9fa19f" class="person" @click="selectMember2(m)">{{ m.name }}</div>
                      </div>
                    </div>
                  </transition>
                </div>

                <div   class="select ">
                  <div @click="open3" class="add" data-id="">
                    <span style="width: 85%"> {{ case1}}</span>
                    <i     class="el-icon-arrow-down el-icon--right"></i> 
                  </div>
                  <transition name="fade">
                    <div v-if="personShow3" class="person-container">
                      <div style="color: #9fa19f" class="person" @click="selectMember3()">{{ $t('message.videoImageCompress') }}</div>
                    </div>
                  </transition>
                </div>
              </div>

              <div v-if="showTeamPrice">
                <div style="margin-top: -50px" class="item box1 on  f_thb1">
                  <div style="display: flex;justify-content: center" class="tbox">
                    <div style="display: flex;justify-content: center" class="pbbs">
                      <div class="options" >
                        <div class="t1">{{this.time+this.member}}</div>
                        <h4 class="t2">¥ {{ price }}</h4>
                        <div class="t3">{{ $t('message.duration') }}{{this.time}}</div>
                        <div class="t4" style="white-space: normal;"><p><img src="https://www.yasubit.com/uploads/ueditor/20210728/1-210HR02521520.png" title="团队成员(图1)" alt="团队成员(图1)" style="max-width:100%!important;height:auto!important;height: auto !important;"/>{{ $t('message.unlimitedVideoSize') }}</p></div><div class="t4" style="white-space: normal;"><img src="https://www.yasubit.com/uploads/ueditor/20210508/1-21050R05643463.png" title="1天会员(图2)" alt="1天会员(图2)" style="max-width:100%!important;height:auto!important;height: auto !important;"/>{{ $t('message.unlimitedImageCount') }}</div><div class="t4" style="white-space: normal;"><img src="https://www.yasubit.com/uploads/ueditor/20210508/1-21050R0564V40.png" title="1天会员(图3)" alt="1天会员(图3)" style="max-width:100%!important;height:auto!important;height: auto !important;"/>{{ $t('message.unlimitedFileSize') }}</div>
                        <a @click="perChaseTeam(price,member+time)" class="buy" order-id="166">{{ $t('message.buyNow') }}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="!showTeamPrice">
                <div class="tbox f_tbox1">
                  <div class="tips">
                    {{ $t('message.selectTeamMember') }}+{{ $t('message.selectDuration') }}+{{ $t('message.selectPackage') }}
                  </div>
                  <div class="pbbs">
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <!-- help -->
    <div class="help">
      <h2 class="title">{{ $t('message.needMoreHelp') }}</h2>
      <div @click="goContact"> <a >{{ $t('message.contactCustomerService') }}</a></div>
    </div>

    <div class="price-tip price-tipgr">
      <div class="box">
        <div class="txt">{{ $t('message.confirmPurchase') }}</div>
        <div class="cbox">
          <div class="cb cb1">{{ $t('message.yes') }}</div>
          <div class="cb cb2">{{ $t('message.no') }}</div>
        </div>
      </div>
    </div>

    <div class="price-tip price-tiptd">
      <div class="box">
        <div class="txt">{{ $t('message.confirmPurchase') }}</div>
        <div class="cbox">
          <div class="cb cb1">{{ $t('message.yes') }}</div>
          <div class="cb cb2">{{ $t('message.no') }}</div>
        </div>
      </div>
    </div>

    <LoginDialog ref="loginDialog"></LoginDialog>
    <Footer/>
  </div>
</template>

<script>
import Header from "@/views/header.vue";
import Banner from "../components/Banner";
import Footer from "@/views/footer.vue";
import Header1 from "@/views/header1.vue";
import LoginDialog from "./loginFront.vue";
import Cookies from "js-cookie";
import axios from "axios";
export default {
  components: {

    Header,
    Banner,
    Footer,
    LoginDialog,
  },
  data() {

    return {
      orderMsg1:"",
      orderMsg2:"",
      orderMsg3:"",
      aid:0,
      token:"",
      totalPerson:0,
      usersPrice:0,
      discount:0,
      price:0,
      memberList:[],
      typeList:[],
      typeList0:[],

      showTeamPrice:false,
      isTeam:false,
      containerHeight: 'auto',
      personShow:false,
      personShow1:false,
      personShow2:false,
      personShow3:false,
      member: "请选择团队成员数",
      time: "请选择会员时长",
      case1: "请选择套餐",
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      value: '',
      isScrolled9: true,
      name:'',
      text: '',
      textarea: '',
      loading: true,
      caseList: [],
      personalPlans: [],
      teamMemberOptions: []
    };
  },
  mounted() {
    // 滚动到顶部
    window.scrollTo(0, 0);
    this.token = localStorage.getItem("loginToken")
    window.addEventListener('scroll', this.handleScroll9);
    // window.console.log("case");
    this.$http
        .get("Cases/GetCasesAll")
        .then(response => {
          //console.log(response);
          this.caseList = response.data;
          //window.console.log(this.caseList);
          this.loading = false;
        })
        .catch(function(error) {
          window.console.log(error);
        });
    this.getPersonalPlans()
    // 初始化多语言文本
    this.member = this.$t('message.selectTeamMember');
    this.time = this.$t('message.selectDuration');
    this.case1 = this.$t('message.selectPackage');

  },
  methods:{
    //团队版生成订单
    getOrderData1() {
      // console.log(this.token)
      this.token = "Bearer " + this.token; // 添加空格
      // 定义请求头，替换 'YourAuthToken' 为你的有效身份验证令牌
      const headers = {"Authorization": this.token};
      // 构建请求参数 - 团队版使用 productType: "2"
      const data = { productId: this.aid, productType: "2" };
      // 发送 POST 请求并在请求中添加自定义请求头
      this.$http.post('/yasubit/shop_order', data, { headers })
          .then(response => {
            // console.log(response.data.data)
            if (response.data.code !== 200) {
              this.$message.error(response.data.msg);
              return ;
            }
            this.orderMsg1=response.data.data.orderCode
            this.orderMsg2=response.data.data.productName
            this.orderMsg3=response.data.data.orderTotalAmount
            this.$message.success(this.$t('message.orderCreatedSuccess'));
            sessionStorage.setItem("orderMsg1", this.orderMsg1)
            sessionStorage.setItem("orderMsg2",this.$t('message.videoImageCompress')+"-"+this.$t('message.teamVersion')+"-" + this.orderMsg2)
            sessionStorage.setItem("orderMsg3",this.price)
            this.$router.push({ path: "pay" });
          })
          .catch(error => {
            // 请求失败时处理错误
            console.error('Error fetching data:', error);
          });
    },


//个人版生成订单
    getOrderData() {
      // console.log(this.token)
      this.token = "Bearer " + this.token; // 添加空格
      // 定义请求头，替换 'YourAuthToken' 为你的有效身份验证令牌
      const headers = {"Authorization": this.token};
      // 构建请求参数
      const data = { productId: this.aid, productType: "1" };
      // 发送 POST 请求并在请求中添加自定义请求头
      this.$http.post('/yasubit/shop_order', data, { headers })
          .then(response => {
            // console.log(response.data.data)
            if (response.data.code !== 200) {
              this.$message.error(response.data.msg);
              return ;
            }
            this.orderMsg1=response.data.data.orderCode
            this.orderMsg2=response.data.data.productName
            this.orderMsg3=response.data.data.orderTotalAmount
            this.$message.success(this.$t('message.orderCreatedSuccess'));
            sessionStorage.setItem("orderMsg1", this.orderMsg1)
            sessionStorage.setItem("orderMsg2",  this.orderMsg2)
            sessionStorage.setItem("orderMsg3",this.orderMsg3)
            this.$router.push({ path: "pay" });
          })
          .catch(error => {
            // 请求失败时处理错误
            console.error('Error fetching data:', error);
          });
    },

    openLoginDialog() {
      // console.log('Opening login dialog');

      this.$refs.loginDialog.showLoginDialog();

    },
    updateUser(newUser) {
      const userData = JSON.stringify(newUser);
      Cookies.set("user", userData, { expires: 30 });
      this.user = newUser;
      this.isLogin = true;
    },
    perChase(item){
      this.aid = item.id;
      this.token = localStorage.getItem("loginToken")
      // 从localStorage中获取保存的数据
      if(localStorage.getItem("loginToken")){
        //已登录
        this.getOrderData()
      }else {
        //未登录
        this.openLoginDialog()
      }
    },
    perChaseTeam(a,b){
      console.log(a,b)
      let caseTime=this.$t('message.videoImageCompress')+"-"+this.$t('message.teamVersion')+"-"+b
      sessionStorage.setItem("casePrice", a)
      sessionStorage.setItem("caseTime", caseTime)
      this.token=localStorage.getItem("loginToken")
      // 从localStorage中获取保存的数据
      if(localStorage.getItem("loginToken")){
        this.getOrderData1()
      }else {
        //未登录
        console.log("未登陆成功")
        this.openLoginDialog()
      }
    },
    goContact(){
      this.$router.push({path:"contact"})
    },
    Persion1(){
      this.isTeam=false
    },
    Persion2(){
this.isTeam=true
    },
    toggleDropdown() {
      this.personShow = !this.personShow;
    },
    toggleDropdown2() {
      this.personShow2 = !this.personShow2;
    },
    toggleDropdown3() {
      this.personShow3 = !this.personShow3;
    },
// 取出数字参数
   extractNumberFromString(inputString) {
  const match = inputString.match(/\d+/);

  if (match) {
    return parseInt(match[0], 10);
  } else {
    return null; // 或者可以返回其他默认值或进行其他处理
  }
},

    selectMember(m) {
      this.member = m.name
      this.discount = 1 // 默认折扣为1，可以根据需要调整
      this.totalPerson = this.extractNumberFromString(m.name)
      // console.log( this.totalPerson)
      this.toggleDropdown(); // 选择后关闭下拉
      if(this.member!==this.$t('message.selectTeamMember')&&this.time!==this.$t('message.selectDuration')&&this.case1!==this.$t('message.selectPackage')){
        // console.log(this.discount)
        this.price= Math.ceil(this.totalPerson*this.usersPrice*this.discount)
        this.showTeamPrice=true
      }
    },
    selectMember2(m) {
      // console.log(m)
      this.time = m.name;
      this.aid = m.id
      this.usersPrice = m.price
      this.toggleDropdown2(); // 选择后关闭下拉
      if(this.member!==this.$t('message.selectTeamMember')&&this.time!==this.$t('message.selectDuration')&&this.case1!==this.$t('message.selectPackage')){
        // console.log(this.discount)
        this.price= Math.ceil(this.totalPerson*this.usersPrice*this.discount)
        this.showTeamPrice=true
      }
    },
    selectMember3() {
      this.case1 = this.$t('message.videoImageCompress');
      this.toggleDropdown3(); // 选择后关闭下拉
      if(this.member!==this.$t('message.selectTeamMember')&&this.time!==this.$t('message.selectDuration')&&this.case1!==this.$t('message.selectPackage')){
        this.price= Math.ceil(this.totalPerson*this.usersPrice*this.discount)
        this.showTeamPrice=true
      }
    },
    open(){
      if (this.personShow) {
        this.personShow = false;
        this.containerHeight = '0'; // 隐藏时高度设为0
      } else {
        this.personShow = true;
        this.containerHeight = 'auto'; // 显示时高度设为auto或者其他适当的值
      }

    },
    open2(){
      if (this.personShow2) {
        this.personShow2 = false;
        this.containerHeight = '0'; // 隐藏时高度设为0
      } else {
        this.personShow2 = true;
        this.containerHeight = 'auto'; // 显示时高度设为auto或者其他适当的值
      }

    },
    open3(){
      if (this.personShow3) {
        this.personShow3 = false;
        this.containerHeight = '0'; // 隐藏时高度设为0
      } else {
        this.personShow3 = true;
        this.containerHeight = 'auto'; // 显示时高度设为auto或者其他适当的值
      }

    },
    handleScroll9() {
      // 获取当前滚动位置
      const scrollY = window.scrollY || window.pageYOffset;

      // 可以设置一个阈值来确定何时改变isScrolled9的值
      const dis = 100;

      // 判断滚动位置是否大于阈值
      if (scrollY > dis) {
        // 向下滚动，将isScrolled9设为false
        this.isScrolled9 = false;
      } else {
        // 向上滚动，将isScrolled9设为true
        this.isScrolled9 = true;
      }
      // const scrollDistance = window.scrollY || document.documentElement.scrollTop;
      // // 当滚动距离小于等于200px时，设置isScrolled9为true
      // this.isScrolled9 = scrollDistance <=500;

    },
    submit(){
      // console.log("内容")

      // Get the input element by its ID
      let a = document.getElementById('usernameInput');
      let b = document.getElementById('usercontactInput');
      let c = document.getElementById('usercontactInput1');
      let d = document.getElementById('usercontactInput2');

      // console.log(a)

      // Get the value entered by the user
      let username = a.value;
      let userPhone = b.value;
      let userEmail = c.value;
      let userIdea = d.value;

      if(username.trim() !== ''&&userPhone.trim() !== ''&&userEmail.trim() !== ''&&userIdea.trim() !== ''){

        const headers =
            {
              'Authorization': '',

            };
        // 定义请求体，替换 'yourPayloadData' 为实际的请求体数据
        const postData = {
          17:username,
          19:userPhone,
          21:userEmail,
          23:userIdea,
          typeid: 67,
        };
        // 发送 POST 请求并在请求中添加自定义请求头
        this.$http.post('yasubit/guestbook/insert', postData, { headers })
            .then(response => {
              // 请求成功时更新数据
              console.log("post成功");
              this.$message.success("提交成功")
              a.value = '';
              b.value = '';
              c.value = '';
              d.value = '';

              // this.data = response.data;
            })
            .catch(error => {
              // 请求失败时处理错误
              console.error('Error fetching data:', error);
            });

      }else {

        this.$message.warning("需填写完整信息")
      }









      this.$http.post('yasubit/guestbook/insert', data)
          .then(response => {
            this.$message.success(response.data.msg);
          })
          .catch(error => {
            this.$message.error(error);
          });
    },
    getPersonalPlans() {
      const headers = {};
      this.$http.get('/yasubit/membership', { headers })
        .then(res => {
          if (res.data.code === 200) {
            this.personalPlans = res.data.data;
            // 为团队版生成固定的成员数选项
            this.teamMemberOptions = [
              { id: 1, name: '5人团队', title: '5人团队' },
              { id: 2, name: '10人团队', title: '10人团队' },
              { id: 3, name: '20人团队', title: '20人团队' },
              { id: 4, name: '50人团队', title: '50人团队' },
              { id: 5, name: '100人团队', title: '100人团队' }
            ];
          }
        });
    }
  }
};
</script>

<style>
.person{
  color:  #9fa19f;
  padding: 10px;
  width: 100%;height:40px; display: flex;justify-content: center;align-items: center;
  cursor: pointer; /* 当鼠标悬停在元素上时显示手型光标 */
}
.person:hover {
  background-color: #a3d0fb; /* 鼠标悬停时的背景颜色 */
}
.person-container {
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.04);
  transition: height 1s ease-in-out; /* 添加过渡效果 */
  overflow: hidden; /* 隐藏溢出部分 */
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>